// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum CustomerPushNotificationProp {
	CreationTime = 'creationTime',
	Id = 'id',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy'
}

export type CustomerPushNotificationPropCreationTime = {
	[CustomerPushNotificationProp.CreationTime] : number | null
}
export type CustomerPushNotificationPropId = {
	[CustomerPushNotificationProp.Id] : number
}
export type CustomerPushNotificationPropModificationTime = {
	[CustomerPushNotificationProp.ModificationTime] : number | null
}
export type CustomerPushNotificationPropModifiedBy = {
	[CustomerPushNotificationProp.ModifiedBy] : models.UserDto
}


export type CustomerPushNotification = 
	CustomerPushNotificationPropCreationTime & 
	CustomerPushNotificationPropId & 
	CustomerPushNotificationPropModificationTime & 
	CustomerPushNotificationPropModifiedBy

export const CUSTOMER_PUSH_NOTIFICATION_PROPERTY_NAMES = Object.freeze([CustomerPushNotificationProp.CreationTime, CustomerPushNotificationProp.Id, CustomerPushNotificationProp.ModificationTime, CustomerPushNotificationProp.ModifiedBy])

export type CustomerPushNotificationDetails = 
	CustomerPushNotificationPropId & 
	CustomerPushNotificationPropCreationTime & 
	CustomerPushNotificationPropModificationTime & 
	CustomerPushNotificationPropModifiedBy

export const CUSTOMER_PUSH_NOTIFICATION_DETAILS_PROPERTY_NAMES = Object.freeze([CustomerPushNotificationProp.Id, CustomerPushNotificationProp.CreationTime, CustomerPushNotificationProp.ModificationTime, CustomerPushNotificationProp.ModifiedBy])
